var map = {
	"./logo_Cfmoto.png": "1bff",
	"./logo_Lambretta.png": "a9d6",
	"./logo_Leopaard.png": "6d97",
	"./logo_Maxion.png": "5449",
	"./logo_Skywell.png": "54e7",
	"./logo_T_King.png": "ddfe",
	"./logo_Ventura.png": "3fa3",
	"./logo_Victory.png": "d14a",
	"./logo_Voyah.png": "5a90",
	"./logo_Wiztem.png": "6b2f",
	"./logo_Yuejin.png": "244d",
	"./logo_acdelco.png": "2715",
	"./logo_agrale.png": "17ae",
	"./logo_aima.png": "b01c",
	"./logo_assai.png": "514f",
	"./logo_aston_martin.png": "2498",
	"./logo_atacadao.png": "75df",
	"./logo_audi.png": "b9f3",
	"./logo_avelloz.png": "1fe3",
	"./logo_baic.png": "bc15",
	"./logo_bajaj.png": "a81c",
	"./logo_baotian.png": "8430",
	"./logo_bashan.png": "86ff",
	"./logo_bee_motos.png": "6dd3",
	"./logo_beiben.png": "2f66",
	"./logo_bentley.png": "35ef",
	"./logo_benzhou.png": "a275",
	"./logo_big.png": "959e",
	"./logo_bmw.png": "98c4",
	"./logo_bourbon.png": "5907",
	"./logo_brandy.png": "339d",
	"./logo_bravax.png": "8ec6",
	"./logo_bretas.png": "4815",
	"./logo_bretas_hiper.png": "54ca",
	"./logo_brilliance.png": "747a",
	"./logo_brp.png": "ee5e",
	"./logo_bugatti.png": "8154",
	"./logo_bull.png": "197f",
	"./logo_byd.png": "2674",
	"./logo_cadillac.png": "942a",
	"./logo_camc.png": "50cf",
	"./logo_caoa_chery.png": "236a",
	"./logo_carrefour.png": "7795",
	"./logo_carrefour_bairro.png": "51cb",
	"./logo_carrefour_hiper.png": "ee4e",
	"./logo_changan.png": "7a85",
	"./logo_changhe.png": "5d3b",
	"./logo_charming.png": "c5e6",
	"./logo_chery.png": "99f0",
	"./logo_chongqing_zongshen.png": "deaa",
	"./logo_chrysler.png": "d5d4",
	"./logo_citroen.png": "c602",
	"./logo_cnj.png": "95be",
	"./logo_condor.png": "98b6",
	"./logo_coradir.png": "3c19",
	"./logo_crosley.png": "5bba",
	"./logo_cupra.png": "f1d8",
	"./logo_daf.png": "56cf",
	"./logo_dafra.png": "b880",
	"./logo_daihatsu.png": "8703",
	"./logo_dayang.png": "4a41",
	"./logo_dayun.png": "a6a1",
	"./logo_deepal.png": "7266",
	"./logo_dfm.png": "f4f9",
	"./logo_dfsk.png": "5fd8",
	"./logo_dodge.png": "79f3",
	"./logo_dongfeng.png": "99b1",
	"./logo_dorcen.png": "c35f",
	"./logo_dpaschoal.png": "c79a",
	"./logo_ds.png": "79e3",
	"./logo_ducati.png": "1edd",
	"./logo_effa.png": "0ba4",
	"./logo_enranger.png": "99af",
	"./logo_extra.png": "d108",
	"./logo_extra_hiper.png": "28bc",
	"./logo_extra_super.png": "9a52",
	"./logo_farizon.png": "5cc4",
	"./logo_faw.png": "60e4",
	"./logo_ferrari.png": "4ebb",
	"./logo_fiat.png": "c790",
	"./logo_fisker.png": "1d1e",
	"./logo_foday.png": "dcd9",
	"./logo_ford.png": "7f05",
	"./logo_forland.png": "e301",
	"./logo_foton.png": "7544",
	"./logo_freightliner.png": "1eee",
	"./logo_fuso.png": "126f",
	"./logo_fyber.png": "250a",
	"./logo_fym.png": "145b",
	"./logo_gac.png": "b229",
	"./logo_garinni.png": "a06a",
	"./logo_gas_station.png": "f2e0",
	"./logo_gbarbosa.png": "5ea6",
	"./logo_gbm_motors.png": "b9e1",
	"./logo_geely.png": "87fd",
	"./logo_gm.png": "bb85",
	"./logo_golden_dragon.png": "e926",
	"./logo_great_wall.png": "60d0",
	"./logo_guangyu.png": "4fe7",
	"./logo_guzzi.png": "f296",
	"./logo_gws.png": "a970",
	"./logo_hanteng.png": "313a",
	"./logo_haobao.png": "1330",
	"./logo_haojue.png": "b16f",
	"./logo_harley_davidson.png": "0c7f",
	"./logo_haval.png": "8ba5",
	"./logo_higer.png": "bf72",
	"./logo_hino.png": "96ba",
	"./logo_hiper_bompreco.png": "27c6",
	"./logo_hiper_todo_dia.png": "ceb7",
	"./logo_hmb.png": "b9b1",
	"./logo_honda.png": "6da5",
	"./logo_honda_moto_pecas.png": "48ba",
	"./logo_huanghai.png": "fd1b",
	"./logo_huari.png": "a1f1",
	"./logo_husqvarna.png": "71cb",
	"./logo_hyosung.png": "6a8d",
	"./logo_hyundai.png": "ce0e",
	"./logo_indian.png": "61e9",
	"./logo_international.png": "8098",
	"./logo_iros.png": "2bb1",
	"./logo_isuzu.png": "79d2",
	"./logo_italika.png": "cb3e",
	"./logo_iveco.png": "c21d",
	"./logo_jac.png": "21b5",
	"./logo_jaguar.png": "0fe4",
	"./logo_jeep.png": "9e44",
	"./logo_jetour.png": "9fe7",
	"./logo_jiayuan.png": "f62e",
	"./logo_jinbei.png": "bea5",
	"./logo_jincheng.png": "a11c",
	"./logo_jmc.png": "b33e",
	"./logo_jonny.png": "7dcc",
	"./logo_jonway.png": "9ce7",
	"./logo_joylong.png": "6958",
	"./logo_jtz.png": "4196",
	"./logo_kaiyi.png": "a0b7",
	"./logo_kama.png": "1e31",
	"./logo_kamaz.png": "0d13",
	"./logo_kangchao.png": "404c",
	"./logo_karma.png": "eed9",
	"./logo_karry.png": "2e0a",
	"./logo_kasinski.png": "3540",
	"./logo_kawasaki.png": "ee3d",
	"./logo_kenworth.png": "65fe",
	"./logo_keyton_motors.png": "61c6",
	"./logo_kia.png": "0e24",
	"./logo_king_long.png": "c2ca",
	"./logo_ktm.png": "a4b4",
	"./logo_kyc.png": "5417",
	"./logo_kymco.png": "5ec9",
	"./logo_lamborghini.png": "c257",
	"./logo_land_rover.png": "4ed2",
	"./logo_lexus.png": "4a94",
	"./logo_lifan.png": "b424",
	"./logo_lincoln.png": "1dfc",
	"./logo_loncin.png": "a1a9",
	"./logo_longjia.png": "0d40",
	"./logo_lotus.png": "9e59",
	"./logo_mack.png": "9549",
	"./logo_magazine.png": "413d",
	"./logo_mahindra.png": "f938",
	"./logo_man.png": "fd00",
	"./logo_marcopolo.png": "3666",
	"./logo_maserati.png": "a19b",
	"./logo_maxi_bodega.png": "cd01",
	"./logo_maxus.png": "651c",
	"./logo_maxxi.png": "a3c0",
	"./logo_mazda.png": "32a2",
	"./logo_mclaren.png": "85bf",
	"./logo_mercadorama.png": "8fba",
	"./logo_mercedes.png": "7182",
	"./logo_mercedes_benz.png": "f658",
	"./logo_mercury.png": "a8b4",
	"./logo_mg.png": "155e",
	"./logo_mini.png": "b9b1b",
	"./logo_mitsubishi.png": "9e43",
	"./logo_miura.png": "7ea4",
	"./logo_morris.png": "62b4",
	"./logo_motocar.png": "14fb",
	"./logo_motorino.png": "80bc",
	"./logo_mv_agusta.png": "08ba9",
	"./logo_mvk.png": "06ba",
	"./logo_nacional.png": "17aee",
	"./logo_nash.png": "3199",
	"./logo_natura.png": "c435",
	"./logo_nazaxx.png": "ee3f",
	"./logo_nissan.png": "8725",
	"./logo_niu.png": "ec31",
	"./logo_o_boticario.png": "8e7e",
	"./logo_oldsmobile.png": "0798",
	"./logo_omoda.png": "7772",
	"./logo_omoda_jaecoo.png": "2d72",
	"./logo_opel.png": "211f",
	"./logo_oshkosh.png": "99c9",
	"./logo_outras.png": "5dd8",
	"./logo_packard.png": "ff48",
	"./logo_panhard.png": "68d1",
	"./logo_peugeot.png": "fb0d",
	"./logo_piaggio.png": "de9e",
	"./logo_pierce_arrow.png": "e68b",
	"./logo_plymouth.png": "ecf3",
	"./logo_polaris.png": "8d0d",
	"./logo_pontiac.png": "6379",
	"./logo_porsche.png": "e80c",
	"./logo_qingling.png": "6811",
	"./logo_qingqi.png": "c59d",
	"./logo_qoros.png": "ac63",
	"./logo_ram.png": "37fd",
	"./logo_rdk.png": "65f9",
	"./logo_rely.png": "5d4a",
	"./logo_renault.png": "f271",
	"./logo_reva.png": "adc4",
	"./logo_rolls_royce.png": "4947",
	"./logo_rosenbauer.png": "91f4",
	"./logo_royal_enfield.png": "718a",
	"./logo_runner.png": "fd2d",
	"./logo_saab.png": "2890",
	"./logo_sam_s_club.png": "41f7",
	"./logo_saturn.png": "6a23",
	"./logo_scania.png": "58b5",
	"./logo_seat.png": "e3a4",
	"./logo_senke.png": "41a2",
	"./logo_sero.png": "76bc",
	"./logo_shaanxi.png": "5785",
	"./logo_shineray.png": "8e76",
	"./logo_sinotruk.png": "1866",
	"./logo_skoda.png": "53df",
	"./logo_skyworth.png": "dac0",
	"./logo_smart.png": "d0f8",
	"./logo_soueast.png": "e8b8",
	"./logo_sousa.png": "222b",
	"./logo_spartan.png": "98b1",
	"./logo_spyker.png": "999a",
	"./logo_ssangyong.png": "cacb",
	"./logo_stark.png": "4d57",
	"./logo_studebaker.png": "5e20",
	"./logo_subaru.png": "9017",
	"./logo_sundown.png": "75aa",
	"./logo_super_600.png": "8938",
	"./logo_super_bompreco.png": "b8ef",
	"./logo_suzuki.png": "2b33",
	"./logo_swm.png": "1f9a",
	"./logo_tata.png": "c37d",
	"./logo_tesla.png": "2daa",
	"./logo_think.png": "f671",
	"./logo_tinbot.png": "567a",
	"./logo_todo_dia.png": "0e02",
	"./logo_todo_dia_1200.png": "d6c9",
	"./logo_toyota.png": "5c55",
	"./logo_traxx.png": "4540",
	"./logo_trillion.png": "5d0b",
	"./logo_triumph.png": "685a",
	"./logo_troller.png": "b53c",
	"./logo_uaz.png": "540b",
	"./logo_ud_trucks.png": "a8f2",
	"./logo_vauxhall.png": "acdd",
	"./logo_vespa.png": "0ad7",
	"./logo_vgv.png": "ca88",
	"./logo_vmoto.png": "d7ef",
	"./logo_volkswagen.png": "8693",
	"./logo_voltz.png": "bec5",
	"./logo_volvo.png": "c87e",
	"./logo_vw.png": "fdd5",
	"./logo_walmart.png": "b295",
	"./logo_wangye.png": "af12",
	"./logo_watts.png": "dfb4",
	"./logo_wazn.png": "a5ba",
	"./logo_weichai.png": "12be",
	"./logo_western_star.png": "9b75",
	"./logo_wiesmann.png": "583d",
	"./logo_willys.png": "c568",
	"./logo_wonjan.png": "2ca7",
	"./logo_wuyang.png": "13c0",
	"./logo_xcmg.png": "50f2",
	"./logo_xiashing.png": "de8b",
	"./logo_yamaha.png": "7b04",
	"./logo_yamasaki.png": "e404",
	"./logo_yema.png": "12a3",
	"./logo_yingang.png": "ed8e",
	"./logo_yinxiang.png": "dd5c",
	"./logo_youngman.png": "b637",
	"./logo_yue_jin.png": "9c5d",
	"./logo_yutong.png": "287c",
	"./logo_zaffari.png": "2c94",
	"./logo_zanella.png": "796d",
	"./logo_zhidou.png": "f44d",
	"./logo_zhongneng.png": "e385",
	"./logo_zhongtong.png": "8543",
	"./logo_zna.png": "03bf",
	"./logo_zotye.png": "411a",
	"./logo_zxauto.png": "a183"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d289";